import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { MedicalInquiryHomePage } from '../../pages/medical-inquiry-home/medical-inquiry-home';
import { MedicalInquiryListComponent } from './medical-inquiry-list/medical-inquiry-list.component';
import { MedicalInquiryNewComponent } from './medical-inquiry-new/medical-inquiry-new.component';
import { MedicalInquiryDetailComponent } from './medical-inquiry-detail/medical-inquiry-detail.component';
import { MedicalInquiryDualSignatureModalComponent } from './medical-inquiry-dual-signature-modal/medical-inquiry-dual-signature-modal.component';

const MEDICAL_INQUIRY_DECLARATIONS = [
  MedicalInquiryHomePage,
  MedicalInquiryListComponent,
  MedicalInquiryNewComponent,
  MedicalInquiryDetailComponent,
  MedicalInquiryDualSignatureModalComponent,
];

@NgModule({
  imports: [SharedModule],
  declarations: MEDICAL_INQUIRY_DECLARATIONS,
  exports: MEDICAL_INQUIRY_DECLARATIONS,
})
export class MedicalInquiryModule {}
